import { AsyncPipe } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SafeHtmlPipe } from '@core/pipes';
import { StorageService, StrapiService } from '@core/services';
import { Account as AccountService } from '@customer/account/account.svc';
import { AuthService } from '@customer/services';
import { SvgIconComponent } from 'angular-svg-icon';
import { BehaviorSubject } from 'rxjs';
import posthog from 'posthog-js';
import { Contact } from '@legacy-models/portal/Contact';
import { Account } from '@legacy-models/portal/Account';

@Component({
  selector: 'oke-documents',
  imports: [ReactiveFormsModule, FormsModule, SvgIconComponent, AsyncPipe, SafeHtmlPipe],
  templateUrl: './documents.html',
  styleUrl: './documents.scss'
})
export class Documents implements OnInit {
  private readonly _storageSvc: StorageService = inject(StorageService);
  private readonly _strapiSvc: StrapiService = inject(StrapiService);
  readonly authSvc: AuthService = inject(AuthService);
  readonly accountSvc: AccountService = inject(AccountService);
  user: Contact;
  acct: Account;
  documentsSource = new BehaviorSubject<{
    title?: string | null;
    description?: string | null;
    documents: any[];
  }>({
    title: null,
    description: null,
    documents: [
      {
        name: 'W9',
        url: 'https://www.irs.gov/pub/irs-pdf/fw9.pdf',
        context: null
      },
      {
        name: 'Change of Address Request',
        url: '/assets/documents/NGGP/Change of Address Request.doc',
        context: null
      },
      {
        name: 'Direct Deposit Form',
        url: '/assets/documents/NGGP/Direct Deposit form 2018.pdf',
        context: null
      },
      {
        name: 'Affidavit of Heirship',
        url: '/assets/documents/NGGP/Affidavit Of Heirship.doc',
        context: null
      }
    ]
  });
  documents$ = this.documentsSource.asObservable();

  constructor() {
    this._storageSvc.currentUser$.subscribe(currUser => {
      if (currUser) {
        this.user = currUser.Contact as Contact;
      }
    });
    this._storageSvc.currentAccount$.subscribe(currAcc => {
      this.acct = currAcc as Account;
    });
    this._storageSvc.setCurrentPage('NGGP Documents');
  }

  ngOnInit(): void {
    this.getStrapiContent();
  }

  getStrapiContent(): void {
    const strapiPageContent = JSON.parse((sessionStorage.getItem('strapiPageNggpDocuments') ?? 'null') as string);
    if (!strapiPageContent) {
      this._strapiSvc.getNggpDocumentsContent().subscribe(content => {
        sessionStorage.setItem('strapiPageNggpDocuments', JSON.stringify(content));
        this.documentsSource.next(content);
      });
    } else {
      this.documentsSource.next(strapiPageContent);
    }
  }

  onDocumentClick(submitEvt: SubmitEvent): void {
    posthog.capture('documents:document_click', {
      document_name: submitEvt.submitter?.dataset.name ?? 'unspecified'
    });
    const clickedBtnElem = (event as SubmitEvent)?.submitter;
    const vAnchorElem = document.createElement('a');
    vAnchorElem.setAttribute('download', '');
    vAnchorElem.href = clickedBtnElem!.dataset.url as string;
    vAnchorElem.target = '_blank';
    document.body.append(vAnchorElem);
    vAnchorElem.click();
    document.body.removeChild(vAnchorElem);
  }

  get isExtraContent(): boolean {
    let isExtraContent = false;
    (['title', 'description'] as const).forEach(property => {
      if (this.documentsSource.value[property]) {
        isExtraContent = true;
      }
    });
    return isExtraContent;
  }
}
